import { ConfigurationPage } from './pages/ConfigurationPage';
import { CallProvider, DeviceCheckOptions, useCallAgent } from "@azure/communication-react";
import CallPage from './pages/CallPage';
import React, { useCallback } from 'react';
import {
    CallEndedOrNotAllowedPage,
    LeftCallPage,
    selectCall,
    selectPage,
    useAdapter,
    useHideExtensionApps,
    usePageSwitcherTracking,
    UnsupportedEnvironmentPage,
    usePcpLiveLessonContext,
} from 'live-lesson/shared/feature-call-ui-react';
import { Call, RoomCallLocator } from '@azure/communication-calling';


const deviceChecks: DeviceCheckOptions = { camera: 'required', microphone: 'required' };

type PageSwitcherProps = {
    callLocator: RoomCallLocator;
    isMobile: boolean;
};

export const PageSwitcher = (props: PageSwitcherProps): JSX.Element => {

    const { isMobile } = props;

    const pageSwitcherPage = usePcpLiveLessonContext(selectPage);
    const callAdapter = useAdapter();
    const callAgent = useCallAgent();
    const isLocalMicrophoneEnabled = usePcpLiveLessonContext(s => s.isLocalPreviewMicrophoneEnabled);
    const envInfo = usePcpLiveLessonContext(s => s.callClientState.environmentInfo);

    const call = usePcpLiveLessonContext(selectCall);
    const setCall = usePcpLiveLessonContext((s) => s.setCall);

    const startCall = useCallback(() => {
        if (callAgent) {
            const onCallsUpdated = (calls: { added: Call[], removed: Call[] }) => {
                const call = calls.added[0];
                setCall(call);
                callAgent.off('callsUpdated', onCallsUpdated);
            }
            callAgent.on('callsUpdated', onCallsUpdated);

            callAdapter.joinCall({
                // keep config page mic enabled/disabled
                microphoneOn: isLocalMicrophoneEnabled,
                cameraOn: "keep",
            });
        }
    }, [callAgent, callAdapter, props.callLocator, isLocalMicrophoneEnabled]);

    useHideExtensionApps();
    usePageSwitcherTracking();

    return (
        <>
            {/*__page: {page}__*/}
            {pageSwitcherPage === 'unsupportedEnvironment' && (
                <UnsupportedEnvironmentPage envInfo={envInfo}/>
            )}

            {pageSwitcherPage === 'expired' && (
                <CallEndedOrNotAllowedPage />
            )}
            {pageSwitcherPage === 'configuration' && (
                <ConfigurationPage
                    mobileView={isMobile}
                    startCallHandler={startCall}
                    latestErrors={[]}
                    onDismissError={() => {}}
                    deviceChecks={deviceChecks}
                />
            )}

            {pageSwitcherPage === 'leftCall' && (
                <LeftCallPage />
            )}

            {call && (

                <CallProvider call={call}>
                    {pageSwitcherPage === 'call' &&
                        <CallPage />
                    }
                </CallProvider>
            )}
        </>
    )
};
